<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-10-10 11:26:12
--> 
<template>
  <div>
    <costCenter></costCenter>
  </div>
</template> 

<script>
import costCenter from './costCenter'
export default {
  components: {
    costCenter
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>